<template>
  <div style="font-size: 14px">
    <div v-if="name==='海报'">
      <div class="search">
        <van-dropdown-menu active-color="#3974c4">
          <van-dropdown-item v-model="border" :options="posterTypeList" />
          <van-dropdown-item v-model="groupId" :options="groupList" v-if="groupId && name !== '海报'" />
        </van-dropdown-menu>
        <van-search v-model="value" shape="round" placeholder="搜索" @search="onSearch" @clear="onCancel" />
      </div>
    </div>
    <div v-else>
      <div class="search">
        <van-dropdown-menu active-color="#3974c4">
          <van-dropdown-item v-model="border" :options="typeList" />
        </van-dropdown-menu>
        <van-search v-model="value" placeholder="搜索" @search="onSearch" @clear="onCancel" shape="round" />
      </div>
      <van-dropdown-menu class="search-group" active-color="#3974c4">
        <van-dropdown-item @change="selectDept" v-model="deptId" :options="deptList" v-if="border === 3 && deptList.length > 0" />
        <van-dropdown-item :title="groupName" ref="item" v-if="groupList.length > 0">
          <multipleSelect ref="selectChild" :parentType="border" :deptId="deptId" :dataList="groupList"
            :groupItem="groupItem" @getGroupItem="getGroupItem" @getIdName="getIdName"
            @getShowPopupTree="getShowPopupTree">
          </multipleSelect>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div class="conte" v-for="item in list" :key="item.id" @click="articleOnclick(item)">
      <div style="display:flex">
        <img v-if="name==='海报'" :src="item.imgWithQrcode" alt="" />
        <img v-if="name==='图集' && item.imgList" :src="item.imgList[0]" alt="" />
        <img v-if="(name==='文章' || name==='文件' || name==='表单') && item.cover" :src="item.cover" alt="" />
      </div>
      <div style="margin: 0 4px; line-height: 25px; width: 100%">{{item.name || item.title}}</div>
      <div class="copy" @click.stop="onclick(item)">发送</div>
    </div>
    <!-- 海报详情popup -->
    <van-popup v-model="showImage" position="bottom" :style="{ height: '85%' }" style="display: flex;justify-content: center;">
        <img style="max-width: 100%" :src="posterImg" alt="" />
    </van-popup>
    <!-- 图集详情popup -->
    <van-popup v-model="showPopupImage" @click-overlay="closePopupImage" position="bottom" :style="{ height: '85%' }">
      <div v-for="(itemImage, indexImage) in imageList" :key="indexImage">
        <img style="max-width: 100%" :src="itemImage" alt="" />
      </div>
    </van-popup>
    <!-- 文章详情popup -->
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '85%' }">
      <div class="popup">
        <van-field class="popup-title" v-model="details.title" input-align="center" rows="1" autosize type="textarea"
          disabled>
        </van-field>
        <van-field class="popup-content" v-html="details.body" rows="1" autosize type="textarea"></van-field>
        <div class="popup-btn">
          <van-button type="primary" @click="onclick(details)">发送</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 视频预览 -->
    <van-popup v-model="showVideo" position="bottom" :style="{ height: '85%' }">
      <video v-if="name==='视频'" style="max-width: 100%" controls="controls" :src="videoUrl">
      </video>
    </van-popup>
    <!-- 表单预览 -->
    <van-popup v-model="showForm" position="bottom" :style="{ height: '85%' }">
      <div class="form_title">{{formTitle}}</div>
      <div class="form_description">{{formDescription}}</div>
      <van-form>
        <div v-for="(item, index) in formList" :key="index">
          <van-field border disabled v-if="item.type === 0" :name="item.name" :label="item.name" v-model="item.value"
            :placeholder="'请填写' + item.name" :rules="[{ required: Boolean(item.isNeed), message: '请填写' }]" />
          <van-field disabled v-if="item.type === 1" rows="1" autosize :label="item.name" v-model="item.value"
            type="textarea" :placeholder="'请输入'+ item.name" />
          <van-field disabled v-if="item.type === 2" type="number" v-model="item.value" :label="item.name"
            :rules="[{ required: Boolean(item.isNeed), message: '请填写' }]" />
          <van-field disabled v-if="item.type === 3" :label="item.name"
            :rules="[{ required: Boolean(item.isNeed), message: '请选择' }]">
            <template #input>
              <van-radio-group disabled v-model="item.value" direction="horizontal">
                <van-radio v-for="(it,index) in item.formProTagReqs" :key="index" :name="it.proValue">{{it.proValue}}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field disabled v-if="item.type === 4" name="checkboxGroup" :label="item.name"
            :rules="[{ required: Boolean(item.isNeed), message: '请选择' }]">
            <template #input>
              <van-checkbox-group disabled v-model="item.value" direction="horizontal">
                <van-checkbox v-for="(it,index) in item.formProTagReqs" :key="index" :name="it.proValue" shape="square">
                  {{it.proValue}}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field disabled v-if="item.type === 5" clickable readonly name="calendar" :label="item.name"
            placeholder="点击选择日期" />
          <van-field readonly clickable v-model="timevalue[index]" v-if="item.type === 6" name="datetimePicker"
            :label="item.name" placeholder="点击选择时间" />
          <van-field v-model="allTime[index]" readonly v-if="item.type === 7" clickable name="datetimePicker"
            :label="item.name" placeholder="点击选择时间" />
        </div>
      </van-form>
    </van-popup>
    <!-- 外部链接详情popup -->
    <van-popup v-model="showLink" position="bottom" :style="{ height: '85%' }">
      <van-field border readonly label="链接标题" :placeholder="details.title" />
      <van-field border readonly label="链接地址" :placeholder="details.url" />
      <van-field border readonly label="描述" :placeholder="details.description" />
    </van-popup>
  </div>
</template>

<script>
import multipleSelect from './../../../components/multipleSelect.vue'
import { flatten } from '../../../utils/index'

export default {
  components: { multipleSelect },
  props: {
    name: {
      type: String
    },
    filterList: {
      type: Array
    },
    titleIndex: {
      type: Number
    },
    sessionId: {
      type: String
    },
  },
  data () {
    return {
      value: "",
      border: 2,
      list: [],
      typeList: [
        { text: '企业库', value: 2 },
        { text: '经销商库', value: 3 },
        { text: '我的库', value: 1 },
      ],
      posterTypeList: [],
      groupId: null, // 分组名id
      groupList: [], // 分组名
      groupItem: {}, // 三级分类的初始化时接收的组对象
      selectNum: 0,
      showPopupTree: false,
      groupName: '',
      deptId: null,
      deptList: [],
      details: {},
      showPopup: false,
      showImage: false,
      imageList: [],
      showPopupImage: false,
      showVideo: false,
      videoUrl: '',
      showForm: false,
      formTitle: '',
      formDescription: '',
      formList: [],
      showLink:false,
      moren: 'https://scrm-saas-1306604067.cos.ap-guangzhou.myqcloud.com/scrm-ui/weifen-logo.jpg',
      posterImg: ''
    }
  },
  watch: {
    filterList (val) {
      this.list = val
    },
    border (val) {
      this.list = []
      this.$emit('type', this.border)
      if (this.name !== '海报') {
        if (this.border === 3) {
          this.changeDeptId()
        } else {
          this.deptId = null
          this.changeGroupName()
        }
      }
    },
    groupId (val) {
      this.list = []
      console.log(val, 'val');
      this.$emit('groupId', val)
    },
    "name": {
      immediate: true, // 首次加载的时候执行函数
      handler: function(val) {
        this.deptId = null
        this.selectNum = 0
        this.border = 2
        if (this.name !== '海报') {
          this.changeGroupName()
        }
      }
    },
    deptId (val) {
      this.list = []
      this.$emit('getDeptId', val)
    },
    selectNum (val) {
      console.log(val, 'val1111111111111111');
    }
  },
  created () {
    this.posterTypeList = this.typeList.filter(item => {
      return item.value === 1 || item.value === 2
    })
    // if (this.name !== '海报') {
    //   this.getGroupList()
    // }
  },
  methods: {
    // 切换库与经销商时，实时更新van-dropdown-item组名
    changeGroupName() {
      this.getGroupList(() => {
        if (this.groupList.length < 1) {
          this.groupId = null
          this.groupItem = {}
          this.groupName = ''

        } else {//显示分组数据
          if (this.groupList[0].hasChildren && this.groupList[0].children[0].hasChildren) {
            this.groupId = this.groupList[0].children[0].id
            this.groupItem = this.groupList[0]
            this.groupName = this.groupList[0].text + '/' + this.groupList[0].children[0].text
          } else {
            this.groupId = this.groupList[0].id
            this.groupItem = this.groupList[0]
            this.groupName = this.groupList[0].text
          }

        }
      })
    },
    // 切换经销商
    selectDept (val) {
      this.deptId = val
      this.changeGroupName()
    },
    // 经销商列表
    initDeptList () {
      this.$http
        .get("/scrm/v1/tenancy-dept/m/contentShareDeptMulTenancy", {})
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.deptList = []
            res.data.forEach(item => {
              if (item.deptList === null || item.deptList === undefined) {
                item.deptList = []
              }
              if (item.deptList.length > 0) {
                item.deptList.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.deptList.push(item.deptList)
              }

            })
            this.deptList = flatten(this.deptList);
            console.log(this.deptList, 'this.deptList');
            if (this.deptList.length > 0) {
              this.deptList.forEach(item => {
                item.text = item.tenancyName + '/ ' + item.name
                item.value = item.id
              })
              this.deptId = this.deptList[0].id
              this.changeGroupName()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupList = []
              this.groupName = ''
              //   this.speechListcontent = []
            }
          }
        });
    },
    changeDeptId () {
        this.selectNum = 1
        this.initDeptList()
    },
    // 接收到子组件传回的数据
    getGroupItem (val) {
      console.log(val, '1呃呃涛涛');
      this.groupItem = val
      this.groupId = val.id
      if (val.children === null || val.children === undefined) {
        val.children = []
      }
      if (this.border === 3) {
        if (this.selectNum % 2 !== 1 && val.children.length < 1) {
          this.$refs.item.toggle();
        }
      } else {
        if (this.selectNum > 0 && val.children.length < 1) {
          this.$refs.item.toggle();
        }
      }
      this.selectNum++
    },
    getIdName (val) {
      this.groupName = val.join('/')
    },
    getShowPopupTree (val) {
      this.showPopupTree = val
    },
    getGroupList (callback) {
      let url;
      if (this.name === '文章') {
        url = '/scrm/v1/ct-article-group/m/findTreeMulTenancy'
      } else if (this.name === '表单') {
        url = '/scrm/v1/ct-form-group/m/findTreeMulTenancy'
      } else if (this.name === '文件') {
        url = '/scrm/v1/ct-file-group/m/findTreeMulTenancy'
      } else if (this.name === '视频') {
        url = '/scrm/v1/ct-video-group/m/findTreeMulTenancy'
      } else if (this.name === '图集') {
        url = '/scrm/v1/ct-img-group/m/findTreeMulTenancy'
      } else if (this.name === '外部链接') {
        url = '/scrm/v1/ct-url-group/m/findTreeMulTenancy'
      }
      this.$http.get(url, { params: { owner: this.border, deptId: this.deptId } }).then(res => {
        if (res.code === 1) {
          if (this.name === '海报') {
            this.groupList = res.data || []
            this.groupList.forEach(item => {
              item.text = item.text || item.name
              item.value = item.id
            })
          }
          else {
            this.groupList = []
            res.data.forEach(item => {
              if (item.tree === null || item.tree === undefined) {
                item.tree = []
              }
              if (item.tree.length > 0) {
                item.tree.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.groupList.push(item.tree)
              }
            })
            this.groupList = flatten(this.groupList); // arr2 [0, 1, 2, 3, 4, 5]
            if (callback) {
              callback()
            }
          }

          // if (this.groupList.length < 1) {
          //   this.groupId = null
          //   this.groupItem = {}
          //   this.groupName = ''
          // } else if (this.groupId !== this.groupList[0].id) {
          //   this.groupId = this.groupList[0].id
          //   this.groupItem = this.groupList[0]
          //   this.groupName = this.groupList[0].text
          // }

          // this.$emit('groupId', this.groupId)
        } else {
          this.$toast(`${res.msg}`)
        }
      }).catch((e) => {
        console.log('捕获到的错误', e)
      })
    },
    onSearch () {
      this.$emit('keyword', this.value)
    },
    onCancel () {
      this.value = ''
      this.$emit('keyword', this.value)
    },
    closePopupImage () {
      this.showPopupImage = false
    },
    // 文章发送
    articleOnclick (item) {
      if (this.name === '文章') {
        this.$http.get('/scrm/v1/ct-article/m/findById', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            console.log('9900', res.data)
            this.details = res.data
            this.showPopup = true
          }
        })
      }

      if (this.name === '图集') {
        this.$http.get('/scrm/v1/ct-img/m/findById', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            this.imageList = res.data.imgList
            this.showPopupImage = true
          }
        })
      }
      if (this.name === '海报') {
        this.showImage = true
        this.posterImg = item.imgWithQrcode
      }
      if (this.name === '视频') {
        this.showVideo = true
        this.videoUrl = item.url
      }
      if (this.name === '表单') {
        this.$http.get('/scrm/v1/ct-form/m/findById', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            this.showForm = true
            this.formTitle = res.data.title
            this.formDescription = res.data.description
            this.formList = res.data.formProExports.map(item => {
              if (item.type === 4) {
                // type=4 复选框，要求传入数组
                item.value = []
              } else {
                item.value = ''
              }
              // this.datavalue.push('')
              // this.timevalue.push('')
              // this.allTime.push('')
              return item
            })
          }
        })
      }
      if (this.name === '外部链接') {
        this.$http.get('/scrm/v1/ct-url/m/findById', {
          params: {
            id: item.id,
          }
        }).then(res => {
          if (res.code === 1) {
            console.log(res);
            this.details = res.data
            this.showLink = true
          }
        })
      }
    },
    onclick (item) {
      console.log(item, 'item');
      let data = {
        contentId: item.id,
        contentType: this.titleIndex,
        sessionId: Number(this.sessionId)
      }
      console.log(data, 'data');
      this.$http.post(`/scrm/v1/qw-session/m/sendContentMsg`, data).then(res => {
        if (res.code === 1) {
          this.$toast('发送成功')
          //   this.$router.go(-1)
          let obj = {
            type: Number(this.$route.query.type),
            contactId: this.$route.query.contactId,
            sessionId: this.$route.query.sessionId,
            accountId: this.$route.query.accountId,
            memo: this.$route.query.memo,
            name: this.$route.query.name
          }
          console.log(obj);
          let { type, contactId, sessionId, accountId, memo, name } = obj

          this.$router.push({ path: '/chatIndex', query: { type, contactId, sessionId, accountId, memo, name } })
        } else {
          this.$toast(`${res.msg}`)
        }
      })
    }
  }
}
</script>
 
<style lang="less" scoped>
.box {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 20px 40px;
  width: 100%;
  .con {
    width: 40%;
    height: 30px;
    background-color: #f0f0f2;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
  }
  .con_color {
    width: 40%;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    background-color: #e6e6ff;
    border: 1px solid #9494e8;
  }
}
.search {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ededed;
  /deep/ .van-dropdown-menu__bar {
    width: 200px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
  }
}
.search-group {
  /deep/ .van-dropdown-menu__bar {
    // width: 200px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
}
/deep/ .van-ellipsis {
  font-size: 13px;
}
.conte {
  padding: 18px 10px;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    display: block;
    width: 50px;
    height: 50px;
    object-fit: contain;
    border-radius: 5px;
  }
  video {
    display: block;
    width: 50px;
    height: 50px;
  }
}
.copy {
  width: 45px;
  height: 25px;
  min-width: 45px;
  margin-left: 10px;
  border: 1px solid #3974c4;
  color: #3974c4;
  font-size: 13px;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
}
.popup {
  padding-bottom: 65px;
  /deep/ img {
    width: 100% !important;
    max-width: 100% !important;
  }
  .popup-title {
    padding: 18px 20px;
    font-weight: bold;
    font-size: 16px;
  }
  /deep/ .van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
  }
  .popup-content {
    display: block;
    padding: 18px 16px;
    font-size: 14px;
    line-height: 24px;
  }
  .popup-btn {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    /deep/.van-button--primary {
      width: 100%;
      background-color: #3974c4;
      border: 0;
      line-height: 45px;
      height: 45px;
    }
  }
}
.form_title {
  text-align: center;
  font-size: 20px;
  margin: 20px auto;
  text-indent: 2rem;
  font-weight: 900 !important;
  padding-right: 2rem;
}
.form_description {
  text-align: center;
  font-size: 14px;
  margin: 10px auto;
}
</style>
